var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9484 11.745L26.4484 2.71311C25.897 2.40963 25.2778 2.25049 24.6484 2.25049C24.019 2.25049 23.3998 2.40963 22.8484 2.71311L6.34844 11.745C5.75803 12.068 5.26544 12.544 4.92234 13.123C4.57925 13.702 4.39828 14.3626 4.39844 15.0356V32.9644C4.39828 33.6374 4.57925 34.298 4.92234 34.877C5.26544 35.456 5.75803 35.9319 6.34844 36.255L22.8484 45.2868C23.3997 45.5907 24.019 45.75 24.6484 45.75C25.2779 45.75 25.8971 45.5907 26.4484 45.2868L42.9484 36.255C43.5388 35.9319 44.0314 35.456 44.3745 34.877C44.7176 34.298 44.8986 33.6374 44.8984 32.9644V15.0356C44.8986 14.3626 44.7176 13.702 44.3745 13.123C44.0314 12.544 43.5388 12.068 42.9484 11.745ZM24.6484 6.85685L38.1484 14.25L34.1303 16.4494L20.6303 9.0581L24.6484 6.85685ZM24.6484 21.6375L11.1484 14.25L15.9409 11.625L29.4409 19.0144L24.6484 21.6375ZM8.89844 18.1481L22.3984 25.5356V39.9112L8.89844 32.52V18.1481ZM26.8984 39.9112V25.5356L31.3984 23.0737V28.5C31.3984 29.0967 31.6355 29.669 32.0574 30.091C32.4794 30.5129 33.0517 30.75 33.6484 30.75C34.2452 30.75 34.8175 30.5129 35.2394 30.091C35.6614 29.669 35.8984 29.0967 35.8984 28.5V20.61L40.3984 18.1481V32.52L26.8984 39.9112Z",
    fill: "url(#paint0_linear_1559_16972)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_16972",
    x1: 24.6484,
    y1: 2.25049,
    x2: 24.6484,
    y2: 45.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.0cfc2115d84f724fb317125a4dbf3bd1.svg";
export { ForwardRef as ReactComponent };